export default "__VITE_ASSET__50254587__"